import { createContext, useContext, useState, useEffect } from "react";

const realEstateContext = createContext();

export const useRealEstateAuth = () => {
    return useContext(realEstateContext);
}

export const RealEstateAuthProvider = ({ children }) => {
    const [isRealEstateAuthenticated, setIsRealEstateAuthenticated] = useState(false);

    // Check authentication status on mount
    useEffect(() => {
        const token = localStorage.getItem('access_token');
        setIsRealEstateAuthenticated(!!token);
    }, []);

    const realEstateLogin = (token) => {
        if (token) {
            localStorage.setItem('access_token', token);
            setIsRealEstateAuthenticated(true);
        }
    }

    const realEstateLogout = () => {
        localStorage.removeItem('access_token');
        setIsRealEstateAuthenticated(false);
    }

    return (
        <realEstateContext.Provider value={{ isRealEstateAuthenticated, realEstateLogin, realEstateLogout }}>
            {children}
        </realEstateContext.Provider>
    )
}
